<article class="card flex flex-col">
  <div class="card__image-container relative overflow-hidden">
    <img
      alt=""
      [src]="imageSrc"
      loading="lazy"
      class="card__img absolute -z-1 top-0 left-0 w-full h-full object-cover"
    />

    <div
      *ngIf="hasTopRightContent"
      class="card__top-content absolute top-2 right-2"
    >
      <ng-content select="[top-right-content]"></ng-content>
    </div>

    <div *ngIf="showImageOverlay" class="card__image-overlay">
      <ng-content select="[image-overlay-content]"></ng-content>
    </div>
  </div>

  <span *ngIf="toptitle" class="mt-2 text-black font-medium">
    {{ toptitle | titlecase }}
  </span>

  <span *ngIf="organizationName" class="text-grey-dark-1 text-sm font-medium">{{
    organizationName
  }}</span>

  <h2 class="card__title-clamp" aria-label="title">
    {{ title }}
  </h2>

  <p *ngIf="subtitle" class="card__subtitle-clamp">
    {{ subtitle }}
  </p>

  <ng-content></ng-content>
</article>
